import { render, staticRenderFns } from "./ItemDetailDialog.vue?vue&type=template&id=33903b9e&"
import script from "./ItemDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ItemDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports